var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D71249",
    d: "M5.88 12.438h9.776a.844.844 0 1 0 0-1.688H5.881l1.09-1.09a.844.844 0 1 0-1.193-1.194l-2.53 2.531a.825.825 0 0 0-.057.062l-.022.03-.027.037c-.008.011-.015.023-.022.036l-.02.034-.019.038-.017.037-.013.037-.015.041-.01.038-.01.042-.006.044c-.002.013-.005.025-.006.038a.846.846 0 0 0-.004.082v.002c0 .027.002.055.004.082.001.013.004.025.006.037l.006.045.01.041.01.039.014.04.014.038.017.036.019.039.02.033.022.037c.008.013.018.024.026.036l.023.03a.85.85 0 0 0 .054.06l.002.002 2.531 2.532a.841.841 0 0 0 1.194 0 .844.844 0 0 0 0-1.193L5.88 12.438z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D71249",
    d: "M20.156 4H9.47a.844.844 0 0 0-.844.844v3.375a.844.844 0 0 0 1.688 0V5.687h9V17.5h-9v-2.531a.844.844 0 0 0-1.688 0v3.375c0 .466.378.843.844.843h10.687a.844.844 0 0 0 .844-.843v-13.5A.844.844 0 0 0 20.156 4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLogout);
export default __webpack_public_path__ + "static/media/Icons_Logout.e744ec353d84c833efecece6dfbb296b.svg";
export { ForwardRef as ReactComponent };